<form #updateFilePathForm="ngForm" name="form" class="d-flex justify-content-between align-items-center px-1 py-3">
  @if (!isPendingFileDownload) {
    @if (!localFile) {
      <button tabindex="-1" (click)="setDefaultPath.emit()" mat-icon-button matTooltip="Set default update agent`s path">
        <mat-icon class="refresh-icon" svgIcon="refresh"></mat-icon>
      </button>

      <div class="main-content">
        <div class="row no-gutters">
          <div class="col-12 col-md-6 col-lg-8 pr-0 pr-md-3 mb-3 mb-md-0">
            <input [disabled]="localFile" #path="ngModel" name="filePath" type="text" class="form-control w-100 h-100"
              [(ngModel)]="filePath" (ngModelChange)="filePathChange.emit(filePath)">
          </div>

          <div class="col-md-6 col-lg-4">
            <div class="row no-gutters d-flex justify-content-between">
              <button matTooltip="Select installer file" mat-raised-button class="col-5 btn select-file" type="button">
                <label class="mb-0 w-100">
                  <input type="file" (change)="setFileData.emit($event.target.files[0])" class="d-none" [accept]="acceptFile">
                  Browse file
                </label>
              </button>


              <button matTooltip="Set new path" (click)="save.emit()" class="col-6 btn"
                [disabled]="!filePath || path.pristine">
                Update path
              </button>
            </div>
          </div>
        </div>
      </div>
    }

    @if (localFile) {
      <button mat-raised-button class="col-12 btn" type="button" (click)="uploadFile.emit()">
        <label class="upload-button mb-0 w-100">
          Upload <i>{{localFile?.name}}</i> file
        </label>

        <span class="delete-file" (click)="localFile = null" [matTooltip]="'Delete ' + localFile.name">&times;</span>
      </button>
    }
  }

  @if (downloadPercentageProgress) {
    <mat-progress-bar [mode]="'determinate'" [value]="downloadPercentageProgress">
    </mat-progress-bar>
  }
</form>
